<template>
  <div
    v-if="error"
    :class="{ 'pl-100px': inline }"
    v-html="getError()"
    class="text-sm text-danger uppercase font-medium mt-1"
  />
</template>

<script>
export default {
  props: {
    error: {
      type: [String, Array],
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getError () {
      let error = ''
      if (typeof this.error === 'string') {
        error = `<p>${this.error}</p>`
      } else {
        this.error.forEach((err) => {
          error += `<p>${err}</p>`
        })
      }
      return error
    }
  }
}
</script>
